import { Box, Grid, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import PaperBox from "components/PaperBox"
import { Area } from "./examresult/Area"
import { Summary } from "./examresult/Summary/Summary"

import LegacyResultDescription from "./examresult/LegacyResultDescription"
import { useTranslation } from "react-i18next"
import { translatedMomentTitle } from "pages/learning/pages/admin/helpers/translatedMomentTitle"

const StyledGrid = styled(Grid)(({ theme }) => ({
  rowReverseMobile: {
    [theme.breakpoints.down("xl")]: {
      flexDirection: "column-reverse"
    }
  }
}))

export const Page = (props) => {
  const { item } = props
  const { t } = useTranslation()
  const courseDetails = t("learning.details.course", { returnObjects: true })
  const assignedCourses =
    Array.isArray(courseDetails) &&
    courseDetails.find((course) => course.examinationType === item.examinationType)
  const areaCount = item.isLegacyResult === 1 ? 0 : item.areas.length

  const nameSwitch = (swedishTitle) => {
    const key = translatedMomentTitle(swedishTitle, t)
    return key ? key : swedishTitle
  }

  return (
    <div>
      <Box mb={5}>
        <Typography variant="h2">
          {assignedCourses ? assignedCourses.examinationName : item.examinationName}
        </Typography>
      </Box>

      <StyledGrid container spacing={3} direction={"row"}>
        <Grid item md={7} lg={8}>
          <PaperBox marginBottom={3} marginTop={0} sx={{ padding: 0 }}>
            {item.isLegacyResult !== 1 ? (
              item.areas
                .filter((x) => x.questions.length > 0)
                .map((item, key) => {
                  const translatedMomentTitle = nameSwitch(item.areaTitle)
                  return (
                    <Area
                      translatedMomentTitle={translatedMomentTitle}
                      assignedCourses={assignedCourses}
                      item={item}
                      key={key}
                      index={key + 1}
                      areaIndex={key}
                      areaCount={areaCount}
                    />
                  )
                })
            ) : (
              <LegacyResultDescription />
            )}
          </PaperBox>
        </Grid>

        <Grid item xs={12} md={5} lg={4}>
          <Summary item={item} />
        </Grid>
      </StyledGrid>
    </div>
  )
}
